module.exports = __webpack_public_path__ + "img/kid.1877fef9.gif";